<template>
  <div class="login-card__register-email-card">
    <div v-if="form.isLoggedId" class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.name_email.header_name') }}</h1>
      <!-- <p class="login-card__title-desc">{{ trans.get('auth.card.name_email.subheader_name') }}</p> -->
    </div>
    <div v-else class="login-card__title-box">
      <h1 class="login-card__title" v-html="trans.get('auth.card.name_email.header_email')"></h1>
      <p class="login-card__title-desc">{{ trans.get('auth.card.name_email.subheader_email') }}</p>
    </div>
    <div>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <div class="row">
          <div class="col-12">
            <validation-provider name="data" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>

        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-group">
            <ValidationProvider name="name" rules="required|min:4|max:12|alpha_num" v-slot="{ errors }" mode="eager">
              <!--              <label for="name"></label>-->
              <input
                type="text"
                id="name"
                class="input-text input-text__underline"
                maxlength="12"
                v-model="form.name"
                :placeholder="trans.get('auth.card.fields.name')"
              />
              <span class="text-danger pos-absolute-center">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider v-if="!form.isLoggedId" name="email" rules="required" v-slot="{ errors }" mode="eager">
              <label class="d-none" for="email"></label>
              <input type="email" id="email" class="input-text__underline" v-model="form.email" :placeholder="trans.get('auth.card.fields.e_mail')" />
              <span class="text-danger pos-absolute-center">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider v-if="!form.isLoggedId" name="password" rules="required" v-slot="{ errors }" mode="eager">
              <div class="input-group is-invalid">
                <label class="d-none" for="password"></label>
                <input
                  :type="passwordInputType"
                  id="password"
                  class="form-control input-text input-text__underline"
                  v-model="form.password"
                  :placeholder="trans.get('auth.card.fields.password')"
                />
                <div class="input-group-append">
                  <button type="button" class="button__password-eye" @click="switchPasswordVisibility"><i class="fa fa-eye" aria-hidden="true"></i></button>
                </div>
              </div>
              <span class="text-danger pos-absolute-center">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <p v-if="!form.isLoggedId" class="login-card__btn-desc--bigger-black">{{ trans.get('auth.card.name_email.private') }}</p>

          <ValidationProvider name="terms_and_age_confirmation" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }" mode="eager">
            <div class="checkbox-standard mt-2">
              <label>
                <input type="checkbox" class="gradient-border" name="terms_and_age_confirmation" v-model="form.termsAndAge" />
                <span class="checkbox-standard__box checkbox-standard__box--small checkbox-standard__box--purple mr-2 border-C63E7C"></span>
                <span
                  class="desc desc--grey desc-- pb-1 line-height-normal color-686868"
                  v-html="trans.get('auth.card.name_email.terms_and_age', { link1: zRoute('page.agb') })"
                ></span>
              </label>
              <div class="text-danger">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>

          <button type="submit" class="button button__fill button--w-100 mt-2 text--smedium">{{ trans.get('auth.card.name_email.continue') }}</button>
        </form>
      </ValidationObserver>

      <p
        class="login-card__btn-desc login-card__btn-desc--pt-1rem line-height-normal color-686868"
        v-html="trans.get('auth.card.registration_footer_text', {link1: '/privacy' , link2: '/agb'})"
      ></p>

      <button v-if="form.isLoggedId" type="button" class="button button__link button__link--underline mt-1 text--smedium" @click="logout">
        {{ trans.get('auth.card.buttons.logout') }}
      </button>
      <button v-else type="button" class="button button__link button__link--underline mt-3 text--smedium" @click="goBack">
        {{ trans.get('auth.card.buttons.back') }}
      </button>
    </div>
  </div>
</template>
<script>
import RegisterMixin from '../../../front/components/Auth/RegisterMixin';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import AuthGoBackMixin from '../../../front/components/Auth/AuthGoBackMixin';

export default {
  components: { ValidationObserver, ValidationProvider },
  mixins: [RegisterMixin, AuthGoBackMixin],
  props: ['swapComponent', 'form'],
  data: () => ({
    passwordInputType: 'password',
  }),
  methods: {
    switchPasswordVisibility() {
      this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      if (this.form.isLoggedId) {
        this.updateUser().then(() => {
          if (this.isEmailVerificationRequired) {
            this.swapComponent('auth-verification-email-card');
          } else {
            this.goToMembers();
          }
        });
      } else {
        this.createUser().then((response) => {
          if (response.data.user_id) {
            this.form.id = response.data.user_id;
            this.form.isLoggedId = true;
          }

          this.updateUser().then(() => {
            if (this.isEmailVerificationRequired) {
              this.swapComponent('auth-verification-email-card');
            } else {
              this.goToMembers();
            }
          });
        });
      }
    },
    logout() {
      axios.post(zRoute('logout')).then(() => {
        this.$emit('reset-form');
        this.swapComponent('auth-welcome-card');
      });
    },
    goToMembers() {
      setTimeout(() => {
        window.location.href = zRoute('front.members.index');
      }, 10);
    },

    goBack() {
      this.swapComponent('auth-preferences-card');
    },
  },
  activated() {
    this.$refs.form.reset();
    this.$emit('update:progress', 100);
    this.$emit('update:step', 5);
  },
};
</script>
